<template>
  <form
    class="hp-search"
    :class="['hp-search--' + variant, { 'hp-search--labeled': showLabels }]"
    @submit.prevent="$emit('search')"
  >
    <div class="hp-search__fields">
      <div class="hp-search__field">
        <label v-if="showLabels" class="hp-search__label" :for="idPrefix + '-keyword'">Keywords</label>
        <div class="hp-search__control">
          <input
            :id="idPrefix + '-keyword'"
            class="hp-search__input hp-search__input--icon"
            :value="filter.search"
            name="keyword"
            type="text"
            placeholder="Job title, keywords, company..."
            autocomplete="off"
            @input="updateFilter('search', $event.target.value)"
          />
        </div>
      </div>

      <div class="hp-search__field">
        <label v-if="showLabels" class="hp-search__label" :for="idPrefix + '-location'">Location</label>
        <div class="hp-search__control">
          <v-autocomplete
            :id="idPrefix + '-location'"
            :value="filter.city_id"
            @input="updateFilter('city_id', $event)"
            :items="locationOptions"
            item-text="text"
            item-value="id"
            placeholder="Select location"
            outlined
            dense
            hide-details
            clearable
            class="hp-search__autocomplete"
            :attach="false"
          >
            <template slot="item" slot-scope="data">
              <v-list-item-content>
                <v-list-item-title v-text="data.item.text" />
                <v-list-item-sub-title v-if="data.item.group" v-text="data.item.group" />
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </div>
      </div>

      <div class="hp-search__field">
        <label v-if="showLabels" class="hp-search__label" :for="idPrefix + '-course'">Course</label>
        <div class="hp-search__control">
          <v-autocomplete
            :id="idPrefix + '-course'"
            :value="filter.course_id"
            @input="updateFilter('course_id', $event)"
            :items="courseOptions"
            item-text="text"
            item-value="id"
            placeholder="Select course"
            outlined
            dense
            hide-details
            clearable
            class="hp-search__autocomplete"
            :attach="false"
          />
        </div>
      </div>

      <div class="hp-search__field hp-search__field--submit" :class="{ 'hp-search__field--with-reset': showReset }">
        <span v-if="showLabels" class="hp-search__label hp-search__label--spacer" aria-hidden="true">Search</span>
        <div class="hp-search__control hp-search__control--btn" :class="{ 'hp-search__control--actions': showReset }">
          <button type="submit" class="hp-search__btn">
            <v-icon class="text-white mr-1" size="18">{{ $icons.magnify }}</v-icon>
            <span>{{ submitLabel }}</span>
          </button>
          <button
            v-if="showReset"
            type="button"
            class="hp-search__reset"
            @click.prevent="$emit('reset')"
          >Reset</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'HomeSearchBar',
  props: {
    filter: { type: Object, required: true },
    courseOptions: { type: Array, default: () => [] },
    locationOptions: { type: Array, default: () => [] },
    variant: {
      type: String,
      default: 'hero',
      validator: v => ['hero', 'compact'].includes(v),
    },
    idPrefix: { type: String, default: 'hp' },
    showLabels: { type: Boolean, default: true },
    showReset: { type: Boolean, default: false },
    submitLabel: { type: String, default: 'Search jobs' },
  },
  methods: {
    updateFilter(key, value) {
      this.$emit('update:filter', { ...this.filter, [key]: value || null });
    },
  },
};
</script>
